import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/table"

import useClanLocalityData from "../../hooks/useClanLocalityData"

const ClanLocality = () => {
	const data = useClanLocalityData()

  const columns = [
    { name: "Locality", key: "locality" },
    { name: "Chinese Name", key: "ccchi" },
    { name: "English Name", key: "cceng" },
  ]


  return (
    <Layout>
      <Seo title="Index of Locality-based Chinese Clan Associations" />

      <Container>
			<h1>Index of Locality-based Chinese Clan Associations</h1>

      <Table
        columns={columns}
        data={data}
        paginationSize={15}
				routeLink={() => "/map"}
				routeState={({ id }) => ({ clanId: id, clanType: "L" })}
      />
      </Container>

    </Layout>
  )
}

export default ClanLocality
